import { render, staticRenderFns } from "./pieCharts.vue?vue&type=template&id=467a12cb"
import script from "./pieCharts.vue?vue&type=script&lang=js"
export * from "./pieCharts.vue?vue&type=script&lang=js"
import style0 from "./pieCharts.vue?vue&type=style&index=0&id=467a12cb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports